<style lang='less'>
  .layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }

  .layout-logo {
    text-align: center;
    width: 500px;
    /* color:#FFF; */
    height: 30px;
    cursor: pointer;
    /* background: #5b6270; */
    border-radius: 3px;
    float: left;
    line-height: 30px;
    position: relative;
    top: 25px;
    left: 20px;
  }

  .layout-nav {
    width: 220px;
    margin: 0 auto;
    margin-right: 20px;
    margin-top: -10px;
  }

  .layout-nav a {
    font-size: 16px;
    line-height: 80px;
    margin-right: 10px;
  }

  .layout-footer-center {
    text-align: center;
  }

  .ivu-btn {
    margin-right: 6px;
  }

  .ivu-menu-horizontal {
    height: 110px;
    line-height: 110px;
  }

  tr.show-border td {
    border-bottom: 1px solid #ccc !important;
  }

  tr.no-border td {
    border: 0px;
  }

  .home-link {
    position: absolute;
    left: 300px;
    top: 0px;
    display: block;
  }

  .go_back_home {
    font-size: 15px;
    width: 1200px;
    margin: 0 auto;
    padding: 24px 10px 10px 0px;

    .back_btn {
      border-radius: 3px;
      background: #2d8cf0;
      width: 120px;
      cursor: pointer;
      text-align: center;
      color: #FFF;
      line-height: 30px;
      height: 30px;
    }
  }
</style>
<template>
  <div>
    <my-header></my-header>
    <div style="padding:10px">
      <div style="margin:0px auto; padding-bottom:50px; max-width:1200px">
        <router-view></router-view>
      </div>
    </div>
    <my-gotop></my-gotop>
    <div style="text-align:center;color:#ccc">
      系统版本 V1.0.0
    </div>
  </div>
</template>
<script>
  import MyHeader from "./components/header.vue"
  import MyFooter from "./components/my-footer.vue"

  export default {
    components: {
      MyHeader,
      MyFooter
    },
    data() {
      return {
        n: 1
      }
    },
    methods: {
     
    },
    mounted() {
     
    }
  }
</script>